module.exports = __webpack_public_path__ + "static/media/villa-branco-4.9eb88990.png";